export default "__VITE_ASSET__9812f409__"